// src/Deer/intent/Compensation/components/shared/NumericInput.tsx
import React, { useState } from 'react';

import { InputV2 } from 'uiToolkitV1/InputV2';

interface NumericInputProps {
  value: string | number;
  onChange: (value: string) => void;
  isDashed?: boolean;
  inputMode?: 'decimal' | 'numeric';
  width?: string | number;
  showPercentage?: boolean;
}

export const NumericPercentageInput: React.FC<NumericInputProps> = ({
  value,
  onChange,
  isDashed,
  inputMode = 'decimal',
  width,
  showPercentage = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Remove % sign and keep only numbers
    const numericValue = e.target.value.replace('%', '').replace(/[^0-9.-]/g, '');
    onChange(numericValue);
  };

  const displayValue = showPercentage && !isFocused ? `${value}%` : value;

  return (
    <InputV2
      value={displayValue}
      onChange={handleChange}
      isDashed={isDashed}
      inputMode={inputMode}
      width={width}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  );
};
